<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span>Mate and Mary—you guys had to live with it before I wrote it, while I was writing it, and now that it’s done, I’ll be mourning it for another year. Rayna, Karen, you guys put up with my inarticulate hand-waving and half-coherent plot summaries with good grace. Thank you, everyone, for being kind when I’m being ridden by the beast. Giving birth to a thing like this ain’t easy.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?9b2f99e6